import { Mark } from "@tiptap/core";

export const SubscriptMark = Mark.create({
    name: "subscript",

    parseHTML() {
        return [{ tag: "sub" }];
    },

    renderHTML() {
        return ["sub", 0];
    },

    addCommands() {
        return {
            toggleSubscript:
                () =>
                    ({ commands }) => {
                        return commands.toggleMark("subscript");
                    },
        };
    },

    addKeyboardShortcuts() {
        return {
            "Mod-,": () => this.editor.commands.toggleSubscript(),
        };
    },
});
